// Single-flight Places loader; resolves false when VITE_GOOGLE_MAPS_API_KEY is unset.

let promise = null;

export function loadGoogleMaps() {
    if (promise) return promise;

    if (window.google?.maps?.places) {
        promise = Promise.resolve(true);
        return promise;
    }

    const key = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
    if (!key) {
        promise = Promise.resolve(false);
        return promise;
    }

    promise = new Promise((resolve, reject) => {
        // loading=async requires a callback (not the script load event) to signal
        // readiness — https://developers.google.com/maps/documentation/javascript/load-maps-js-api
        const callbackName = "__betonijerryGoogleMapsReady";
        window[callbackName] = () => {
            delete window[callbackName];
            if (window.google?.maps?.places) {
                resolve(true);
            } else {
                promise = null;
                reject(new Error("Google Maps places library failed to initialize"));
            }
        };

        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places&language=fi&region=FI&loading=async&callback=${callbackName}`;
        script.async = true;
        script.addEventListener("error", () => {
            delete window[callbackName];
            promise = null;
            reject(new Error("Google Maps JS failed to load"));
        }, { once: true });
        document.head.appendChild(script);
    });

    return promise;
}
